var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.059 17C43.8099 17 42.7061 16.2489 41.9955 15.222C39.8133 12.0686 36.1194 10 32.0058 10C25.3762 10 20.0019 15.3726 20.0019 22V26H14V22C14 12.0589 22.0615 4 32.0058 4C38.7101 4 44.5587 7.66302 47.658 13.0963C48.7116 14.9433 47.1859 17 45.059 17Z",
    fill: "url(#paint0_radial_169_65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 28C8 24.6863 10.6863 22 14 22H50C53.3137 22 56 24.6863 56 28V54C56 57.3137 53.3137 60 50 60H14C10.6863 60 8 57.3137 8 54V28Z",
    fill: "url(#paint1_linear_169_65)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42.6185C34 41.9045 34.411 41.2704 34.9024 40.7525C35.5827 40.0354 36 39.0665 36 38C36 35.7909 34.2091 34 32 34C29.7909 34 28 35.7909 28 38C28 39.0665 28.4173 40.0354 29.0976 40.7525C29.589 41.2704 30 41.9045 30 42.6185V46C30 47.1046 30.8954 48 32 48C33.1046 48 34 47.1046 34 46V42.6185Z",
    fill: "url(#paint2_linear_169_65)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_169_65",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.0481 17.5) rotate(-110.53) scale(29.365 31.5957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.311175,
    stopColor: "#2E2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724231,
    stopColor: "#566C80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_65",
    x1: 56,
    y1: 60,
    x2: 19.0139,
    y2: 13.2807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223916,
    stopColor: "#FF7E07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE607"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_169_65",
    x1: 35.4783,
    y1: 48,
    x2: 35.4783,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.340681,
    stopColor: "#2E2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#566C80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.3e4d28b0d4d41f65e9866f4bd6e85deb.svg";
export { ForwardRef as ReactComponent };